import React, { useState } from 'react';

const ShowPasswordInput = ({
  name = 'password',
  label,
  value,
  onChange,
  className = 'my-6 relative z-0 w-full',
  isPasswordValid = true,
  showPasswordRules = false,
  focusRingColor = 'focus:ring-[#114175]',
  ...restProps
}: any) => {
  const [showPassword, setShowPassword] = useState(false);
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <>
      <div className={className}>
        <div className="relative">
          <input
            name={name}
            id="password"
            placeholder=" "
            type={showPassword ? 'text' : 'password'}
            className={`block py-2.5 px-3 w-full text-sm text-gray-900 bg-white border border-gray-300 rounded-md appearance-none focus:outline-none focus:ring-2 ${focusRingColor} focus:border-transparent pr-16`}
            value={value}
            onChange={onChange}
            {...restProps}
          />
          <button
            type="button"
            className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600"
            onClick={togglePasswordVisibility}
          >
            {showPassword ? (
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
              </svg>
            ) : (
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
              </svg>
            )}
          </button>
          {label && (
            <label
              htmlFor="password"
              className="peer-focus:font-medium absolute text-sm text-gray-500 origin-left duration-300 transform -translate-y-6 scale-75 top-3 -z-10 origin-0 peer-focus:left-0 peer-focus:text-[#16A34A] peer-focus:dark:text-[#16A34A] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-8 pl-[8px]"
            >
              {label}
            </label>
          )}
        </div>

        {value && !isPasswordValid && showPasswordRules && (
          <span className="text-xs text-red-600 mt-1 block">
            Your password must have 8 or more characters, upper and lowercase
            letters, at least one number, and at least one special character.
          </span>
        )}
      </div>
    </>
  );
};

export default ShowPasswordInput;
